import { useEffect, useState } from 'react';
export const useIsChanged = (value, reset) => {
    const [isChanged, setIsChanged] = useState(false);
    useEffect(() => {
        setIsChanged(true);
    }, [value]);
    useEffect(() => {
        setIsChanged(false);
    }, [reset]);
    return isChanged;
};
export default useIsChanged;
